const hagreedData = Hagreed;

// Token de recette
const hagreedManager = new hagreedData.default('58b2510d-cd6a-4f7a-9596-14d5b3456dcd-0db9012d-192d-44ab-8c5d-4a5e2ff2c92e');

hagreedManager.template = hagreedData.TemplateEnum.FULLPAGE;
hagreedManager.hagreedContent = {
    logoUrl: "https://francoise-paviot.myshopify.com/cdn/shop/files/images.png?v=1769690482&width=110"
}

hagreedManager.cookiesList = [{
    id: 'shopify',
    name: 'Shopify',
    category: hagreedData.CategoryEnum.NECESSARY
}, {
    id: 'google_recaptcha',
    name: 'Google Recaptcha',
    category: hagreedData.CategoryEnum.NECESSARY
}, {
    id: 'google_analytics',
    name: 'Google Analytics',
    category: hagreedData.CategoryEnum.STATISTIQUES
}];

hagreedManager.timeout = 0;
hagreedManager.init();

document.addEventListener('DOMContentLoaded', () => {
    var openHagreedElement = document.getElementById('open-hagreed');
    if (openHagreedElement) {
        openHagreedElement.addEventListener('click', function() {
            hagreedManager.displayBanner();
        });
    }
});
